import { render, staticRenderFns } from "./NavHeader.vue?vue&type=template&id=23468a20&scoped=true&"
import script from "./NavHeader.vue?vue&type=script&lang=js&"
export * from "./NavHeader.vue?vue&type=script&lang=js&"
import style0 from "./NavHeader.vue?vue&type=style&index=0&id=23468a20&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23468a20",
  null
  
)

export default component.exports